// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.material-design-icon[data-v-48dfde24] {
  display: flex;
  align-self: center;
  justify-self: center;
  align-items: center;
  justify-content: center;
}
/**
 * @copyright Copyright (c) 2019 John Molakvoæ <skjnldsv@protonmail.com>
 *
 * @author John Molakvoæ <skjnldsv@protonmail.com>
 *
 * @license GNU AGPL version 3 or any later version
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
button[data-v-48dfde24]:not(.button-vue),
input[data-v-48dfde24]:not([type=range]),
textarea[data-v-48dfde24] {
  margin: 0;
  padding: 7px 6px;
  cursor: text;
  color: var(--color-text-lighter);
  border: 1px solid var(--color-border-dark);
  border-radius: var(--border-radius);
  outline: none;
  background-color: var(--color-main-background);
  font-size: 13px;
}
button[data-v-48dfde24]:not(.button-vue):not(:disabled):not(.primary):hover,
button[data-v-48dfde24]:not(.button-vue):not(:disabled):not(.primary):focus,
button:not(.button-vue):not(:disabled):not(.primary).active[data-v-48dfde24],
input[data-v-48dfde24]:not([type=range]):not(:disabled):not(.primary):hover,
input[data-v-48dfde24]:not([type=range]):not(:disabled):not(.primary):focus,
input:not([type=range]):not(:disabled):not(.primary).active[data-v-48dfde24],
textarea[data-v-48dfde24]:not(:disabled):not(.primary):hover,
textarea[data-v-48dfde24]:not(:disabled):not(.primary):focus,
textarea:not(:disabled):not(.primary).active[data-v-48dfde24] {
  border-color: var(--color-primary-element);
  outline: none;
}
button[data-v-48dfde24]:not(.button-vue):not(:disabled):not(.primary):active,
input[data-v-48dfde24]:not([type=range]):not(:disabled):not(.primary):active,
textarea[data-v-48dfde24]:not(:disabled):not(.primary):active {
  color: var(--color-text-light);
  outline: none;
  background-color: var(--color-main-background);
}
button[data-v-48dfde24]:not(.button-vue):disabled,
input[data-v-48dfde24]:not([type=range]):disabled,
textarea[data-v-48dfde24]:disabled {
  cursor: default;
  opacity: .5;
  color: var(--color-text-maxcontrast);
  background-color: var(--color-background-dark);
}
button[data-v-48dfde24]:not(.button-vue):required,
input[data-v-48dfde24]:not([type=range]):required,
textarea[data-v-48dfde24]:required {
  box-shadow: none;
}
button[data-v-48dfde24]:not(.button-vue):invalid,
input[data-v-48dfde24]:not([type=range]):invalid,
textarea[data-v-48dfde24]:invalid {
  border-color: var(--color-error);
  box-shadow: none !important;
}
button:not(.button-vue).primary[data-v-48dfde24],
input:not([type=range]).primary[data-v-48dfde24],
textarea.primary[data-v-48dfde24] {
  cursor: pointer;
  color: var(--color-primary-element-text);
  border-color: var(--color-primary-element);
  background-color: var(--color-primary-element);
}
button:not(.button-vue).primary[data-v-48dfde24]:not(:disabled):hover,
button:not(.button-vue).primary[data-v-48dfde24]:not(:disabled):focus,
button:not(.button-vue).primary[data-v-48dfde24]:not(:disabled):active,
input:not([type=range]).primary[data-v-48dfde24]:not(:disabled):hover,
input:not([type=range]).primary[data-v-48dfde24]:not(:disabled):focus,
input:not([type=range]).primary[data-v-48dfde24]:not(:disabled):active,
textarea.primary[data-v-48dfde24]:not(:disabled):hover,
textarea.primary[data-v-48dfde24]:not(:disabled):focus,
textarea.primary[data-v-48dfde24]:not(:disabled):active {
  border-color: var(--color-primary-element-light);
  background-color: var(--color-primary-element-light);
}
button:not(.button-vue).primary[data-v-48dfde24]:not(:disabled):active,
input:not([type=range]).primary[data-v-48dfde24]:not(:disabled):active,
textarea.primary[data-v-48dfde24]:not(:disabled):active {
  color: var(--color-primary-element-text-dark);
}
button:not(.button-vue).primary[data-v-48dfde24]:disabled,
input:not([type=range]).primary[data-v-48dfde24]:disabled,
textarea.primary[data-v-48dfde24]:disabled {
  cursor: default;
  color: var(--color-primary-element-text-dark);
  background-color: var(--color-primary-element);
}
/**
 * @copyright Copyright (c) 2019 John Molakvoæ <skjnldsv@protonmail.com>
 *
 * @author John Molakvoæ <skjnldsv@protonmail.com>
 * @author Marco Ambrosini <marcoambrosini@icloud.com>
 *
 * @license GNU AGPL version 3 or any later version
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
li.active[data-v-48dfde24] {
  background-color: var(--color-background-hover);
  border-radius: 6px;
  padding: 0;
}
.action--disabled[data-v-48dfde24] {
  pointer-events: none;
  opacity: .5;
}
.action--disabled[data-v-48dfde24]:hover,
.action--disabled[data-v-48dfde24]:focus {
  cursor: default;
  opacity: .5;
}
.action--disabled *[data-v-48dfde24] {
  opacity: 1 !important;
}
.action-input[data-v-48dfde24] {
  display: flex;
  align-items: flex-start;
  width: 100%;
  height: auto;
  margin: 0;
  padding: 0;
  cursor: pointer;
  white-space: nowrap;
  color: var(--color-main-text);
  border: 0;
  border-radius: 0;
  background-color: transparent;
  box-shadow: none;
  font-weight: 400;
}
.action-input__icon-wrapper[data-v-48dfde24] {
  display: flex;
  align-self: center;
  align-items: center;
  justify-content: center;
}
.action-input__icon-wrapper[data-v-48dfde24] .material-design-icon {
  width: 44px;
  height: 44px;
  opacity: 1;
}
.action-input__icon-wrapper[data-v-48dfde24] .material-design-icon .material-design-icon__svg {
  vertical-align: middle;
}
.action-input > span[data-v-48dfde24] {
  cursor: pointer;
  white-space: nowrap;
}
.action-input__icon[data-v-48dfde24] {
  min-width: 0;
  min-height: 0;
  padding: 22px 0 22px 44px;
  background-position: 14px center;
  background-size: 16px;
}
.action-input__form[data-v-48dfde24] {
  display: flex;
  align-items: center;
  flex: 1 1 auto;
  margin: 4px 0;
  padding-right: 14px;
}
.action-input__container[data-v-48dfde24] {
  width: 100%;
}
.action-input__input-container[data-v-48dfde24] {
  display: flex;
}
.action-input__input-container .colorpicker__trigger[data-v-48dfde24],
.action-input__input-container .colorpicker__preview[data-v-48dfde24] {
  width: 100%;
}
.action-input__input-container .colorpicker__preview[data-v-48dfde24] {
  width: 100%;
  height: 36px;
  border-radius: var(--border-radius-large);
  border: 2px solid var(--color-border-maxcontrast);
  box-shadow: none !important;
}
.action-input__text-label[data-v-48dfde24] {
  padding: 4px 0;
  display: block;
}
.action-input__text-label--hidden[data-v-48dfde24] {
  position: absolute;
  left: -10000px;
  top: auto;
  width: 1px;
  height: 1px;
  overflow: hidden;
}
.action-input__datetimepicker[data-v-48dfde24] {
  width: 100%;
}
.action-input__datetimepicker[data-v-48dfde24] .mx-input {
  margin: 0;
}
.action-input__multi[data-v-48dfde24] {
  width: 100%;
}
li:last-child > .action-input[data-v-48dfde24] {
  padding-bottom: 10px;
}
li:first-child > .action-input[data-v-48dfde24]:not(.action-input--visible-label) {
  padding-top: 10px;
}
`, "",{"version":3,"sources":["webpack://./node_modules/@nextcloud/vue/dist/assets/index-9020d9ca.css"],"names":[],"mappings":"AAAA,gBAAgB;AAChB;EACE,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;;;;;;;;;;;;;;;;;;;;EAoBE;AACF;;;EAGE,SAAS;EACT,gBAAgB;EAChB,YAAY;EACZ,gCAAgC;EAChC,0CAA0C;EAC1C,mCAAmC;EACnC,aAAa;EACb,8CAA8C;EAC9C,eAAe;AACjB;AACA;;;;;;;;;EASE,0CAA0C;EAC1C,aAAa;AACf;AACA;;;EAGE,8BAA8B;EAC9B,aAAa;EACb,8CAA8C;AAChD;AACA;;;EAGE,eAAe;EACf,WAAW;EACX,oCAAoC;EACpC,8CAA8C;AAChD;AACA;;;EAGE,gBAAgB;AAClB;AACA;;;EAGE,gCAAgC;EAChC,2BAA2B;AAC7B;AACA;;;EAGE,eAAe;EACf,wCAAwC;EACxC,0CAA0C;EAC1C,8CAA8C;AAChD;AACA;;;;;;;;;EASE,gDAAgD;EAChD,oDAAoD;AACtD;AACA;;;EAGE,6CAA6C;AAC/C;AACA;;;EAGE,eAAe;EACf,6CAA6C;EAC7C,8CAA8C;AAChD;AACA;;;;;;;;;;;;;;;;;;;;;EAqBE;AACF;EACE,+CAA+C;EAC/C,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,oBAAoB;EACpB,WAAW;AACb;AACA;;EAEE,eAAe;EACf,WAAW;AACb;AACA;EACE,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,SAAS;EACT,UAAU;EACV,eAAe;EACf,mBAAmB;EACnB,6BAA6B;EAC7B,SAAS;EACT,gBAAgB;EAChB,6BAA6B;EAC7B,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;AACZ;AACA;EACE,sBAAsB;AACxB;AACA;EACE,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,gCAAgC;EAChC,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,WAAW;AACb;AACA;EACE,aAAa;AACf;AACA;;EAEE,WAAW;AACb;AACA;EACE,WAAW;EACX,YAAY;EACZ,yCAAyC;EACzC,iDAAiD;EACjD,2BAA2B;AAC7B;AACA;EACE,cAAc;EACd,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,SAAS;EACT,UAAU;EACV,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,WAAW;AACb;AACA;EACE,SAAS;AACX;AACA;EACE,WAAW;AACb;AACA;EACE,oBAAoB;AACtB;AACA;EACE,iBAAiB;AACnB","sourcesContent":["@charset \"UTF-8\";\n.material-design-icon[data-v-48dfde24] {\n  display: flex;\n  align-self: center;\n  justify-self: center;\n  align-items: center;\n  justify-content: center;\n}\n/**\n * @copyright Copyright (c) 2019 John Molakvoæ <skjnldsv@protonmail.com>\n *\n * @author John Molakvoæ <skjnldsv@protonmail.com>\n *\n * @license GNU AGPL version 3 or any later version\n *\n * This program is free software: you can redistribute it and/or modify\n * it under the terms of the GNU Affero General Public License as\n * published by the Free Software Foundation, either version 3 of the\n * License, or (at your option) any later version.\n *\n * This program is distributed in the hope that it will be useful,\n * but WITHOUT ANY WARRANTY; without even the implied warranty of\n * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the\n * GNU Affero General Public License for more details.\n *\n * You should have received a copy of the GNU Affero General Public License\n * along with this program. If not, see <http://www.gnu.org/licenses/>.\n *\n */\nbutton[data-v-48dfde24]:not(.button-vue),\ninput[data-v-48dfde24]:not([type=range]),\ntextarea[data-v-48dfde24] {\n  margin: 0;\n  padding: 7px 6px;\n  cursor: text;\n  color: var(--color-text-lighter);\n  border: 1px solid var(--color-border-dark);\n  border-radius: var(--border-radius);\n  outline: none;\n  background-color: var(--color-main-background);\n  font-size: 13px;\n}\nbutton[data-v-48dfde24]:not(.button-vue):not(:disabled):not(.primary):hover,\nbutton[data-v-48dfde24]:not(.button-vue):not(:disabled):not(.primary):focus,\nbutton:not(.button-vue):not(:disabled):not(.primary).active[data-v-48dfde24],\ninput[data-v-48dfde24]:not([type=range]):not(:disabled):not(.primary):hover,\ninput[data-v-48dfde24]:not([type=range]):not(:disabled):not(.primary):focus,\ninput:not([type=range]):not(:disabled):not(.primary).active[data-v-48dfde24],\ntextarea[data-v-48dfde24]:not(:disabled):not(.primary):hover,\ntextarea[data-v-48dfde24]:not(:disabled):not(.primary):focus,\ntextarea:not(:disabled):not(.primary).active[data-v-48dfde24] {\n  border-color: var(--color-primary-element);\n  outline: none;\n}\nbutton[data-v-48dfde24]:not(.button-vue):not(:disabled):not(.primary):active,\ninput[data-v-48dfde24]:not([type=range]):not(:disabled):not(.primary):active,\ntextarea[data-v-48dfde24]:not(:disabled):not(.primary):active {\n  color: var(--color-text-light);\n  outline: none;\n  background-color: var(--color-main-background);\n}\nbutton[data-v-48dfde24]:not(.button-vue):disabled,\ninput[data-v-48dfde24]:not([type=range]):disabled,\ntextarea[data-v-48dfde24]:disabled {\n  cursor: default;\n  opacity: .5;\n  color: var(--color-text-maxcontrast);\n  background-color: var(--color-background-dark);\n}\nbutton[data-v-48dfde24]:not(.button-vue):required,\ninput[data-v-48dfde24]:not([type=range]):required,\ntextarea[data-v-48dfde24]:required {\n  box-shadow: none;\n}\nbutton[data-v-48dfde24]:not(.button-vue):invalid,\ninput[data-v-48dfde24]:not([type=range]):invalid,\ntextarea[data-v-48dfde24]:invalid {\n  border-color: var(--color-error);\n  box-shadow: none !important;\n}\nbutton:not(.button-vue).primary[data-v-48dfde24],\ninput:not([type=range]).primary[data-v-48dfde24],\ntextarea.primary[data-v-48dfde24] {\n  cursor: pointer;\n  color: var(--color-primary-element-text);\n  border-color: var(--color-primary-element);\n  background-color: var(--color-primary-element);\n}\nbutton:not(.button-vue).primary[data-v-48dfde24]:not(:disabled):hover,\nbutton:not(.button-vue).primary[data-v-48dfde24]:not(:disabled):focus,\nbutton:not(.button-vue).primary[data-v-48dfde24]:not(:disabled):active,\ninput:not([type=range]).primary[data-v-48dfde24]:not(:disabled):hover,\ninput:not([type=range]).primary[data-v-48dfde24]:not(:disabled):focus,\ninput:not([type=range]).primary[data-v-48dfde24]:not(:disabled):active,\ntextarea.primary[data-v-48dfde24]:not(:disabled):hover,\ntextarea.primary[data-v-48dfde24]:not(:disabled):focus,\ntextarea.primary[data-v-48dfde24]:not(:disabled):active {\n  border-color: var(--color-primary-element-light);\n  background-color: var(--color-primary-element-light);\n}\nbutton:not(.button-vue).primary[data-v-48dfde24]:not(:disabled):active,\ninput:not([type=range]).primary[data-v-48dfde24]:not(:disabled):active,\ntextarea.primary[data-v-48dfde24]:not(:disabled):active {\n  color: var(--color-primary-element-text-dark);\n}\nbutton:not(.button-vue).primary[data-v-48dfde24]:disabled,\ninput:not([type=range]).primary[data-v-48dfde24]:disabled,\ntextarea.primary[data-v-48dfde24]:disabled {\n  cursor: default;\n  color: var(--color-primary-element-text-dark);\n  background-color: var(--color-primary-element);\n}\n/**\n * @copyright Copyright (c) 2019 John Molakvoæ <skjnldsv@protonmail.com>\n *\n * @author John Molakvoæ <skjnldsv@protonmail.com>\n * @author Marco Ambrosini <marcoambrosini@icloud.com>\n *\n * @license GNU AGPL version 3 or any later version\n *\n * This program is free software: you can redistribute it and/or modify\n * it under the terms of the GNU Affero General Public License as\n * published by the Free Software Foundation, either version 3 of the\n * License, or (at your option) any later version.\n *\n * This program is distributed in the hope that it will be useful,\n * but WITHOUT ANY WARRANTY; without even the implied warranty of\n * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the\n * GNU Affero General Public License for more details.\n *\n * You should have received a copy of the GNU Affero General Public License\n * along with this program. If not, see <http://www.gnu.org/licenses/>.\n *\n */\nli.active[data-v-48dfde24] {\n  background-color: var(--color-background-hover);\n  border-radius: 6px;\n  padding: 0;\n}\n.action--disabled[data-v-48dfde24] {\n  pointer-events: none;\n  opacity: .5;\n}\n.action--disabled[data-v-48dfde24]:hover,\n.action--disabled[data-v-48dfde24]:focus {\n  cursor: default;\n  opacity: .5;\n}\n.action--disabled *[data-v-48dfde24] {\n  opacity: 1 !important;\n}\n.action-input[data-v-48dfde24] {\n  display: flex;\n  align-items: flex-start;\n  width: 100%;\n  height: auto;\n  margin: 0;\n  padding: 0;\n  cursor: pointer;\n  white-space: nowrap;\n  color: var(--color-main-text);\n  border: 0;\n  border-radius: 0;\n  background-color: transparent;\n  box-shadow: none;\n  font-weight: 400;\n}\n.action-input__icon-wrapper[data-v-48dfde24] {\n  display: flex;\n  align-self: center;\n  align-items: center;\n  justify-content: center;\n}\n.action-input__icon-wrapper[data-v-48dfde24] .material-design-icon {\n  width: 44px;\n  height: 44px;\n  opacity: 1;\n}\n.action-input__icon-wrapper[data-v-48dfde24] .material-design-icon .material-design-icon__svg {\n  vertical-align: middle;\n}\n.action-input > span[data-v-48dfde24] {\n  cursor: pointer;\n  white-space: nowrap;\n}\n.action-input__icon[data-v-48dfde24] {\n  min-width: 0;\n  min-height: 0;\n  padding: 22px 0 22px 44px;\n  background-position: 14px center;\n  background-size: 16px;\n}\n.action-input__form[data-v-48dfde24] {\n  display: flex;\n  align-items: center;\n  flex: 1 1 auto;\n  margin: 4px 0;\n  padding-right: 14px;\n}\n.action-input__container[data-v-48dfde24] {\n  width: 100%;\n}\n.action-input__input-container[data-v-48dfde24] {\n  display: flex;\n}\n.action-input__input-container .colorpicker__trigger[data-v-48dfde24],\n.action-input__input-container .colorpicker__preview[data-v-48dfde24] {\n  width: 100%;\n}\n.action-input__input-container .colorpicker__preview[data-v-48dfde24] {\n  width: 100%;\n  height: 36px;\n  border-radius: var(--border-radius-large);\n  border: 2px solid var(--color-border-maxcontrast);\n  box-shadow: none !important;\n}\n.action-input__text-label[data-v-48dfde24] {\n  padding: 4px 0;\n  display: block;\n}\n.action-input__text-label--hidden[data-v-48dfde24] {\n  position: absolute;\n  left: -10000px;\n  top: auto;\n  width: 1px;\n  height: 1px;\n  overflow: hidden;\n}\n.action-input__datetimepicker[data-v-48dfde24] {\n  width: 100%;\n}\n.action-input__datetimepicker[data-v-48dfde24] .mx-input {\n  margin: 0;\n}\n.action-input__multi[data-v-48dfde24] {\n  width: 100%;\n}\nli:last-child > .action-input[data-v-48dfde24] {\n  padding-bottom: 10px;\n}\nli:first-child > .action-input[data-v-48dfde24]:not(.action-input--visible-label) {\n  padding-top: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
